<template>
  <div class="overlay" :style="{height: isShow?'100%':'0%'}">
    <div class="btn-group" :style="{display: isShow?'':'none'}">
      <div class="btn-group-item" @click="closePreview()">
        <i class="el-icon-close btn-group-item-icon-size"></i><br />
        <span class="btn-group-item-font-size">{{ $t('close') }}</span>
      </div>
      <div class="btn-group-item" @click="downloadPreview()">
        <i class="el-icon-download btn-group-item-icon-size"></i><br />
        <span class="btn-group-item-font-size">{{ $t('download') }}</span>
      </div>
      <div class="btn-group-item" @click="printPreview()">
        <i class="el-icon-printer btn-group-item-icon-size"></i><br />
        <span class="btn-group-item-font-size">{{ $t('print') }}</span>
      </div>
    </div>
    <document-container-component
      :special-offer-detail="specialOfferDetail"
      :agent="selectedAgent"
      :is-template="false"
      :hotel="hotel"
      :room-type-list="roomTypeList"
    ></document-container-component>
    <iframe width="0" height="0" id="printSpecialOfferIframe" name="printSpecialOfferIframe"></iframe>
  </div>
</template>
<script>
import i18nMessages from '@/translations/SpecialOffer/components/PreviewSpecialOffer.i18n'
import DocumentContainerComponent from './PreviewSpecialOffer/DocumentContainerComponent'
import { SPECIAL_OFFER_REF_CODE_TYPE, SPECIAL_OFFER_STATUS, STATUS } from '@/configs/constant'

export default {
  name: 'PreviewSpecialOfferByAgentComponent',
  components: {
    DocumentContainerComponent
  },
  i18n: { messages: i18nMessages },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    hotel: {
      type: Object,
      default: () => {
        return {}
      }
    },
    specialOfferDetail: {
      type: Object,
      default: () => {
        return {
          hotelId: '',
          hotelInformation: {
            code: '',
            name: ''
          },
          promotion: {},
          agentList: [],
          salePerson: {},
          refCode: '',
          refCodeSuffixType: SPECIAL_OFFER_REF_CODE_TYPE.AGENT_NAME,
          autoRefCode: STATUS.DISABLE,
          startDate: '',
          endDate: '',
          issueDate: '',
          internalNote: '',
          footerMessage: '',
          bodyMessage: '',
          allotmentList: [],
          status: SPECIAL_OFFER_STATUS.DRAFT
        }
      }
    },
    selectedAgent: {
      type: Object,
      default: () => {
        return {
          name: '',
          information: {
            address: '',
            country: '',
            emailList: [],
            faxList: [],
            phoneList: [],
            zipCode: ''
          },
          contactPerson: {
            emailList: [],
            firstName: '',
            lastName: '',
            title: '',
            position: ''
          }
        }
      }
    },
    roomTypeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      isShow: false,
      SPECIAL_OFFER_STATUS: SPECIAL_OFFER_STATUS
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShow = newValue
    }
  },
  methods: {
    closePreview: function () {
      this.isShow = false
      this.$emit('onClose')
    },
    downloadPreview: function () {
      this.isShow = false
      this.$emit('onDownload')
    },
    printPreview: function () {
      const documentContent = document.getElementById('special-offer-document').innerHTML
      const iframe = window.frames['printSpecialOfferIframe']
      iframe.document.write('<html><head><title>my div</title>')
      iframe.document.write('<style> body {font-family: "Arial"; font-size: 14px}</style>')
      iframe.document.write('</head><body onload="window.print()">')
      iframe.document.write(documentContent)
      iframe.document.write('</body></html>')
      iframe.document.close()
    }
  }
}
</script>
<style scoped>
  .overlay {
    width: 100%;
    position: fixed;
    z-index: 10000;
    bottom: 0;
    left: 0;
    background-color: #ffffff;
    overflow-x: hidden;
    transition: 0.5s;
    height: 0;
    min-width: 1024px;
  }

  .overlay a {
    padding: 8px;
    text-decoration: none;
    font-size: 36px;
    color: #818181;
    display: block;
    transition: 0.3s;
  }

  .overlay a:hover, .overlay a:focus {
    color: #f1f1f1;
  }

  .overlay .btn-group {
    position: fixed;
    top: 0px;
    right: 45px;
    width: 300px;
    height: 80px;
    text-align: center;
    z-index: 10;
  }
  .btn-group-item {
    float: right;
    background-color: rgba(53, 53, 53, 0.8);
    height: 70px;
    width: 80px;
    margin-left: 3px;
    color: #ffffff;
    text-align: center;
    vertical-align: bottom;
    padding-top: 10px;
    cursor: pointer;
  }

  .btn-group-item:hover {
    background-color: rgba(102, 170, 241, 0.8);
  }
  .btn-group-item-font-size {
    font-size: 9px;
    font-weight: bold;
  }
  .btn-group-item-icon-size {
    font-size: 40px;
  }

  .editor-preview .table {
    margin: 0;
  }

  .editor-preview table {
    width: 100%;
  }

  .helping-tag {
    background-color: #78C0D8;
    color: #ffffff;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 15px;
    font-size: 15px;
  }
</style>
